export enum V2ToastType {
  Success,
  Info,
  Error
}
